export class Product {
    $key?:string;
    name:string;
    category:string;
    img:string;
    quantity:number;
    price:number;
    size:string;
    brand:string;
    color:string;
    date:string;

}


// WEBPACK FOOTER //
// E:/Project/posSystem/src/app/pos/modals/product.modals.ts